export default __webpack_public_path__ + "static/media/interactive-website-demo.bada8417.mp4";